import { capture, initPostHog } from "./posthog";

export type SpiritualProfileEventName =
  | "spiritual_profile_created"
  | "spiritual_profile_viewed"
  | "entity_added"
  | "entity_selected"
  | "entity_removed"
  | "entity_visibility_changed"
  | "line_selected"
  | "development_stage_selected"
  | "development_stage_changed"
  | "custom_entity_created"
  | "spiritual_profile_form_chat_started"
  | "spiritual_profile_form_chat_field_collected"
  | "spiritual_profile_form_chat_completed"
  | "spiritual_profile_form_chat_submitted"
  | "spiritual_profile_form_chat_submit_error";

type SpiritualProfileEventProperties = {
  terreiroId?: string;
  mediumId?: string;
  lineId?: string;
  entityId?: string;
  visibility?: "only_me" | "leaders" | "terreiro";
  developmentStage?:
    | "initial_contact"
    | "developing"
    | "confirmed"
    | "active_work";
  sourcePage?: string;
};

const SPIRITUAL_PROFILE_ANALYTICS_ENABLED =
  (import.meta.env?.VITE_POSTHOG_SPIRITUAL_PROFILE_ENABLED as
    | string
    | undefined) !== "false";

export const trackSpiritualProfileEvent = (
  event: SpiritualProfileEventName,
  properties: SpiritualProfileEventProperties,
): void => {
  if (!SPIRITUAL_PROFILE_ANALYTICS_ENABLED) return;

  initPostHog();
  capture(event, {
    flow: "spiritual_profile",
    event_version: 1,
    ts_iso: new Date().toISOString(),
    source_page: properties.sourcePage ?? "SpiritualProfile",
    terreiro_id: properties.terreiroId ?? null,
    medium_id: properties.mediumId ?? null,
    line_id: properties.lineId ?? null,
    entity_id: properties.entityId ?? null,
    visibility: properties.visibility ?? null,
    development_stage: properties.developmentStage ?? null,
  });
};
